/**
 * CouponsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import CouponsContext from './coupons-context'
import {
  fetchCoupons,
  fetchCoupon,
  fetchCouponPublicShow,
} from './coupons-api'

export default function CouponsProvider({ children }) {
  const state = {
    fetchCoupon,
    fetchCoupons,
    fetchCouponPublicShow,
  };
  return (
    <CouponsContext.Provider value={state}>
      {children}
    </CouponsContext.Provider>
  )
}
